function inventory(state = {}, action) {
  switch (action.type) {
    case 'SET_CART_INVENTORY_CHECK': {
      return { ...state, inventory: action.items };
    }
    default:
      return state;
  }
}

export default inventory;
